(function(){
  // Initialize Swiper

  var items = document.querySelectorAll('.product-variant-exclusive-coupons-swiper:not([initialized])')
  console.log(items)

  items.forEach(function(item) {
    var variantId = item.getAttribute('data-variant')
    var slides = item.querySelectorAll('.swiper-slide')
    
    var swiper = new Swiper('.product-variant-exclusive-coupons-swiper-' + variantId, {
      effect: 'cards',
      grabCursor: true,
      direction: 'vertical',
      slidesPerView: 'auto',
      loop: true,
      pagination: {
        el: '.swiper-pagination-' + variantId,
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next-' + variantId,
        prevEl: '.swiper-button-prev-' + variantId,
      },
      cardsEffect: {
        perSlideOffset: 10, // Space between cards in px
        perSlideRotate: 0, // Rotation of cards in degrees
        rotate: 0,
      },
    });

    slides.forEach(function(slide, index) {
      var copyBtn = slide.querySelector(`.product-variant-exclusive-coupons-btn-${index+1}`)
      var code = slide.getAttribute('data-code')
      console.log(code,'-----------',copyBtn)

      const clipboard = new ClipboardJS(copyBtn, {
        text: function() {
          return code;
        }
      }); 

      clipboard.on('success', function(e) {
        e.clearSelection();
        e.trigger.textContent = 'Copied!';
        setTimeout(() => {
          e.trigger.textContent = 'Copy Code';
        }, 3000);
      });
    })
    // console.log(item, variantId)
  })

  document.addEventListener('variant:change', function (evt) {
    var allItems = document.querySelectorAll('.product-variant-exclusive-coupons-swiper')
    var activeItem = document.querySelector('.product-variant-exclusive-coupons-swiper-'+evt.detail.variant.id)

    allItems.forEach(function (item) {
      item.style.display = 'none'
    })

    if (activeItem) {
      activeItem.style.display = 'block'

      var variantId = evt.detail.variant.id
    
      var swiper = new Swiper('.product-variant-exclusive-coupons-swiper-' + variantId, {
        effect: 'cards',
        grabCursor: true,
        direction: 'vertical',
        slidesPerView: 'auto',
        loop: true,
        pagination: {
          el: '.swiper-pagination-' + variantId,
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next-' + variantId,
          prevEl: '.swiper-button-prev-' + variantId,
        },
        cardsEffect: {
          perSlideOffset: 10, // Space between cards in px
          perSlideRotate: 0, // Rotation of cards in degrees
          rotate: 0,
        },
      });
    }
  });
})()